/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-28 16:03:18
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import PlanBanner from 'src/components/views/common/banners/plan-search-banner';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';
import ProcessAddonV4 from 'src/components/views/subscription-v4/addon/process-addon';

import { withI18n } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import { ADDONS_INFO, ADDONS_INFO_V4, AI_POWERED_SEARCH_NAME } from 'src/constants/subscription';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { URL } from 'src/constants/links';

import * as SemanticActions from 'actions/semantic-action';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';

import waveIcon from 'src/assets/images/common/wave-warning-icon.png';
import unionIcon from 'src/assets/images/common/union-icon.png';
import aiIcon from 'src/assets/images/common/ai-powered-icon.png';

const RELEASE_SEMANTIC_TIME = 1702443600;
const RenderUnlockBanner = props => {
  const [modalAddon, setModalAddon] = useState(false);
  const [dismissSemanticActive, setDismissSemanticActive] = useState(false);
  const [dismissPreRankingActive, setDismissPreRankingActive] = useState(false);
  const {
    notAllowAddon,
    getAddonStatus,
    getSettings,
    selectedPlan,
    triggerCheckSyncSemantic,
    enableAISearch,
    getDetailInvoice,
    addonStatus,
    statusStore,
    selectedId,
    enabledSubscriptionV4,
    useBoltOn,
    i18n
  } = props;
  // Check current addon search status
  const trialEndDate = _.get(addonStatus, 'trialInfo.trialEndDate', 0);
  const today = new Date().getTime() / 1000;
  const isSubscribeNow =
    !['trial', 'expiredSoon'].includes(statusStore) && trialEndDate >= 0 && trialEndDate < today;
  const subscribedAt = _.get(addonStatus, 'addOnInfo.subscribedAt', 0);
  const isSubscribeBeforeReleaseSemantic = subscribedAt && subscribedAt < RELEASE_SEMANTIC_TIME;
  const showSemanticBanner =
    enableAISearch && !dismissSemanticActive && isSubscribeBeforeReleaseSemantic;
  const showUnlockBanner = !enableAISearch && selectedId !== routes.synonym.view() && !useBoltOn;
  const showPreRanking = enableAISearch && !dismissPreRankingActive;
  /** Subscribe addon - reload page*/
  const handleAfterSubscribeAddon = () => {
    getAddonStatus(AI_POWERED_SEARCH_NAME);
    getSettings();
    getDetailInvoice();
    triggerCheckSyncSemantic();
  };

  useEffect(() => {
    // Check show info banner
    let dismissSemantic = false;
    let dismissPreRanking = false;
    try {
      dismissSemantic = localStorage.getItem(`${getShop()}-dismissSemanticActive`);
      dismissPreRanking = localStorage.getItem(`${getShop()}-dismissPreRankingActive`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismissSemantic === 'true') {
      setDismissSemanticActive(true);
    }
    if (dismissPreRanking === 'true') {
      setDismissPreRankingActive(true);
    }
  }, []);

  // Handle dismiss info banner try out advanced search and go to advanced page
  const onTryOut = name => {
    try {
      localStorage.setItem(`${getShop()}-${name}`, true);
    } catch (error) {}
    switch (name) {
      case 'dismissSemanticActive': {
        setDismissSemanticActive(true);
        history.push(routes.semanticSearch.view());
        return;
      }
      case 'dismissPreRankingActive': {
        setDismissSemanticActive(true);
        history.push(routes.productPerformanceRanking.view());
        return;
      }
      default:
        return;
    }
  };

  return (
    <div style={{ marginRight: '8px', marginTop: '8px' }}>
      {/* Banner unlock trial Addon AI-Power-search */}
      {showUnlockBanner && (
        <PlanBanner
          title={i18n.translate('AdminHTML.StandardSearch.AddonBanner.title')}
          status="warning"
          icon="rocket"
          action={{
            content: selectedPlan.includes('freemium')
              ? i18n.translate(`AdminHTML.Common.Action.upgradeToUnlock`)
              : i18n.translate(
                  `AdminHTML.Common.Action.${
                    isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'
                  }`
                ),
            onAction: () => {
              if (selectedPlan.includes('freemium')) {
                history.push(routes.subscription.package());
                return;
              }
              setModalAddon(true);
            },
            disabled: notAllowAddon
          }}
          imageTop={unionIcon}
          imageBottom={waveIcon}>
          <div style={{ marginTop: '12px' }} className="addon-standard-search">
            <ul style={{ margin: '0', paddingLeft: '20px' }}>
              <li>{i18n.translate('AdminHTML.StandardSearch.AddonBanner.content01')}</li>
              <li>{i18n.translate('AdminHTML.StandardSearch.AddonBanner.content02')}</li>
              <li>{i18n.translate('AdminHTML.StandardSearch.AddonBanner.content03')}</li>
              {/* <li>
                <p>{i18n.translate('AdminHTML.StandardSearch.AddonBanner.content04')}</p>
                {/* <a
                  href={URL['Link_V2_Search_Synonym_ManualGuide']}
                  target="_blank"
                  rel="noopener noreferrer">
                  {i18n.translate('AdminHTML.Common.Action.learnMore')}
                  <Icon source={ExternalMinor} />
                </a> }
              </li> */}
            </ul>
          </div>
        </PlanBanner>
      )}

      {/* temporary hide this banner as discuss with BA */}
      {/* {enableAISearch && (
        <PlanBanner
          title={i18n.translate('AdminHTML.StandardSearch.UnlockedBanner.title')}
          status="warning"
          icon="rocket"
          action={{
            content: i18n.translate(`AdminHTML.StandardSearch.UnlockedBanner.action`),
            onAction: () => onTryOut()
          }}
          imageTop={unionIcon}
          imageBottom={waveIcon}
        />
      )}*/}

      {/* Banner introduce product performance ranking*/}
      {showPreRanking && (
        <PlanBanner
          title={i18n.translate('AdminHTML.ProductPerformanceRanking.IntroduceFeature.title')}
          status="warning"
          icon="rocket"
          action={{
            content: i18n.translate(`AdminHTML.ProductPerformanceRanking.IntroduceFeature.action`),
            icon: aiIcon,
            onAction: () => onTryOut('dismissPreRankingActive')
          }}
          imageTop={unionIcon}
          imageBottom={waveIcon}>
          <div style={{ marginTop: '12px' }} className="intro-new-product-performance-ranking">
            <p>{i18n.translate('AdminHTML.ProductPerformanceRanking.IntroduceFeature.content')}</p>
            <a
              href={URL['Link_Search_Product_Performance_Ranking_Guide']}
              target="_blank"
              rel="noopener noreferrer">
              {i18n.translate('AdminHTML.Common.Action.learnMore')}
              <Icon source={ExternalMinor} />
            </a>
          </div>
        </PlanBanner>
      )}

      {!!showSemanticBanner && (
        <PlanBanner
          title={i18n.translate('AdminHTML.StandardSearch.IntroduceSemanticBanner.title')}
          status="warning"
          icon="rocket"
          action={{
            content: i18n.translate(`AdminHTML.StandardSearch.IntroduceSemanticBanner.action`),
            icon: aiIcon,
            onAction: () => onTryOut('dismissSemanticActive')
          }}
          imageTop={unionIcon}
          imageBottom={waveIcon}>
          <div style={{ marginTop: '12px' }} className="addon-standard-search">
            <ul style={{ margin: '0', paddingLeft: '20px' }}>
              <li>
                {i18n.translate('AdminHTML.StandardSearch.IntroduceSemanticBanner.content01')}
              </li>
              <li>
                <p>
                  {i18n.translate('AdminHTML.StandardSearch.IntroduceSemanticBanner.content02')}
                </p>
              </li>
            </ul>
          </div>
        </PlanBanner>
      )}

      {enabledSubscriptionV4 ? (
        <ProcessAddonV4
          openModalReview={modalAddon}
          addon={ADDONS_INFO_V4.find(e => e.addonName === AI_POWERED_SEARCH_NAME)}
          hadSubscribed={isSubscribeNow}
          handleAfterSubscribeAddon={handleAfterSubscribeAddon}
          handleReviewModal={() => setModalAddon(!modalAddon)}
        />
      ) : (
        <ProcessAddon
          openModalReview={modalAddon}
          addon={ADDONS_INFO.find(e => e.addonName === AI_POWERED_SEARCH_NAME)}
          hadSubscribed={isSubscribeNow}
          handleAfterSubscribeAddon={handleAfterSubscribeAddon}
          handleReviewModal={() => setModalAddon(!modalAddon)}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    useBoltOn: _.get(state.oauth, 'subscription.useBoltOn', false),
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    addonStatus: _.get(state.subscriptionV3, `addonStatus.${AI_POWERED_SEARCH_NAME}`, {}),
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan', ''),
    enabledSubscriptionV4: _.get(
      state.oauth.tenantApp,
      'settings.subscriptionV4.settings.enable',
      false
    ),
    enableAISearch: _.get(
      state.oauth.tenantApp,
      'settings.instantSearch.settings.AI-synonyms',
      false
    )
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getSettings: () => dispatch(SemanticActions.getSemanticSettings()),
  triggerCheckSyncSemantic: () => dispatch(SemanticActions.triggerCheckSyncSemantic()),
  // Get current status addon sync
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n))
});
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(RenderUnlockBanner));
